import type { SyncStatus } from '@/api/generated/model';
import type { StatusTone } from '@/lib/ui/status-tone';

/** Semantic text color for signed P&L / balance deltas. */
export const PNL_TONE_TEXT: Record<'gain' | 'loss' | 'flat', string> = {
  gain: 'text-fin-gain',
  loss: 'text-fin-loss',
  flat: 'text-fin-gray-400',
};

/** Progress fill for tax-wrapper allowance consumption (0–1 ratio). */
export function allowanceUsedTone(ratio: number): StatusTone {
  if (ratio >= 0.95) return 'danger';
  if (ratio >= 0.75) return 'warning';
  return 'success';
}

export function syncStatusTone(status: SyncStatus): StatusTone {
  switch (status) {
    case 'synced':
      return 'success';
    case 'pending':
      return 'warning';
    case 'error':
      return 'danger';
    case 'manual':
    default:
      return 'muted';
  }
}

export function syncStatusLabelKey(status: SyncStatus): string {
  return `accounts.syncStatus.${status}`;
}
